<template>
  <el-dialog
    class="registe-dialog"
    :visible.sync="visible"
    :title="$t('course.coursecomment.dialogReplyTitle')"
    :close-on-click-modal="isClose"
    :close-on-press-escape="isClose"
    :show-close="true"
    append-to-body
    @close="dialogReplyClose"
    width="800px"
  >
    <div class="el-dialog__header_cus" slot="title">
      {{ $t("course.coursecomment.dialogReplyTitle") }}
    </div>
    <div>
      <el-form
        ref="dataForm"
        :model="dialogReplyData"
        label-position="center"
        :rules="dialogReplyrules"
        label-width="100px"
      >
        <div class="courseQuestion">
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('course.coursecomment.dialogUserName')" prop="userName">
              <span>{{ dialogReplyData.userName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item
                :label="$t('course.coursecomment.dialogRealName')"
                prop="realName"
              >
                <span>{{ dialogReplyData.realName }}</span>
              </el-form-item>
            </el-col>
            </el-row>

            <el-row>
            <el-col :span="8">
              <el-form-item
                :label="$t('course.coursecomment.dialogPracticalScore')"
                prop="practicalScore"
              >
                <span>{{ dialogReplyData.practicalScore }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                prop="dialogInterestScore"
                :label="$t('course.coursecomment.dialogInterestScore')"
              >
                <span>{{ dialogReplyData.interestScore }}</span>
              </el-form-item>
            </el-col>

            <el-col :span="10">
              <el-form-item
                prop="dialogInformationScore"
                :label="$t('course.coursecomment.dialogInformationScore')"
              >
                <span>{{ dialogReplyData.informationScore }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('course.coursecomment.dialogcontent')" prop="content">
                              <!-- <el-tooltip
                  v-if="dialogReplyData.content"
                  placement="top-end"
                  :content="dialogReplyData.content"
                >
                  <div slot="content">{{ dialogReplyData.content }}</div>
                  <span
                    v-if="
                      dialogReplyData.content &&
                      dialogReplyData.content.length > 30
                    "
                    >{{ dialogReplyData.content.slice(0, 30) }}...</span
                  >
                  <span v-else-if="dialogReplyData.content">{{
                    dialogReplyData.content
                  }}</span>
                </el-tooltip> -->

                <el-input
                  cols="100"
                  type="textarea"
                  v-model="dialogReplyData.content"
                  show-word-limit
                  maxlength="500"
                  :readonly="true"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('course.coursecomment.dialogreply')" prop="reply">
                <el-input
                  cols="100"
                  type="textarea"
                  v-model="dialogReplyData.reply"
                  show-word-limit
                  maxlength="500"
                  placeholder="可输入不超过500的文字信息"

                  :autosize="{ minRows: 6, maxRows: 6 }"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- 取消 -->
      <el-button     @click="dialogReplyClose">{{ $t("course.coursecomment.cancel") }}</el-button>
      <!-- 确定 -->
      <el-button

        v-loading="doalogReplyLoading"
        type="primary"
        @click="saveCourseReply"
        >{{ $t("confirm") }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      doalogReplyLoading: false,
      replyId: 0,
      visible: false,
      isClose: true, //控制弹框能否关闭
      userId: "",
      replyURL: "/course/courseComment/saveCourseCommentReply",
      dialogReplyData: {
        reply:""
      },
      dialogReplyrules: {
        reply: [
          {
            required: true,
            message: this.$t("course.coursecomment.replyPrompt"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 按钮权限


    // 回复
    saveCourseReply() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let repllyData = {};
          repllyData.content = this.dialogReplyData.reply;
          repllyData.courseCommentId = this.dialogReplyData.courseCommentId;

          console.log("this.userData.userId::::::" + this.userId);
          this.doalogReplyLoading = true;
          this.$request
            .post(this.replyURL + "?userId=" + this.userId, repllyData)
            .then((res, total, code, data) => {
              this.doalogReplyLoading = false;

              if (code == 1) {
                this.$message({
                  type: "success",
                  message: this.$t("course.coursecomment.replySuccess"),
                });
                this.dialogReplyClose();
              } else {
                this.$message({
                  type: "success",
                  message: this.$t("course.coursecomment.replyFail"),
                });
              }

              this.$emit('refresh',true);
            })
            .catch(() => {
              console.log(" this.$message");
              this.doalogReplyLoading = false;
            });
        }
      });
    },
    dialogReplyClose() {
      this.visible = false;
      // this.$refs["dataForm"].resetFields();
      this.$emit("getDataList");
    },
  },
  mounted() {
    //取得当前登录者
    this.userId = this.getStorage(this.GLOBAL.USER_DATA).userId;
  },
};
</script>


<style lang="scss">
.registe-dialog {
  .dialog-footer {
    margin: 10px;
    padding-bottom: 20px !important;
    padding-top: 0px !important;
    align-content: right;
  }
  .el-textarea__inner {
    resize: none !important;
    border-radius: 4px!important;
  }
  .courseQuestion .el-form-item span {
  // font-weight: 560;
  // font-size: 16px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 20px;
  color: #0b0b0b;
  }
  .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 20px 24px;
    width: 800px;
    .el-dialog__header_cus {
      height: 22px;
      line-height: 22px;
      color: rgba(37, 38, 40, 100);
      font-size: 16px;
      position: relative;
      padding-left: 11px;
      font-weight: 600;
      &::before {
        content: "";
        width: 3px;
        height: 14px;
        border-radius: 1px;
        display: inline-block;
        background-color: rgba(28, 105, 212, 1);
        position: absolute;
        top: 4px;
        left: 0px;
      }
    }
  }
  .el-form-item__label {
    color: #848383;
  }
  .el-form-item {
    width: 100% !important;
  }
  .courseQuestion .el-form-item__label {
    color: #848383;
  }
}
</style>
